var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "page",
    [
      _c(
        "div",
        {
          staticClass: "pane-container",
          staticStyle: { background: "#fff", padding: "12px" },
        },
        [
          _c(_setup.SearchRenderer, {
            attrs: { query: _setup.searchForm, schema: _setup.searchSchema },
            on: { search: _setup.handleSearch, reset: _setup.handleReset },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pane-container",
          staticStyle: {
            background: "#fff",
            padding: "12px",
            "margin-top": "12px",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "actions",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _setup.handleAddCategory },
                },
                [_vm._v("新增分类")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _setup.handleAddQuestion },
                },
                [_vm._v("新增问题")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _setup.categoryList,
                        border: "",
                        stripe: "",
                        size: "small",
                        "highlight-current-row": "",
                      },
                      on: {
                        "current-change": _setup.handleCategoryCurrentChange,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "type_name",
                          label: "分类名称",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(_setup.LanguageInputEcho, {
                                  attrs: { obj: row.type_name },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "100",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleEditCategory(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleDeleteCategory(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _setup.questionLoading,
                          expression: "questionLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _setup.questionList,
                        border: "",
                        stripe: "",
                        size: "small",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "title",
                          label: "问题标题",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(_setup.LanguageInputEcho, {
                                  attrs: { obj: row.title },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "is_hot",
                          label: "是否热门",
                          width: "90",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.is_hot === 1 ? "success" : "info",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(row.is_hot === 1 ? "是" : "否") +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operator",
                          label: "编辑人",
                          "min-width": "100",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "updated_at",
                          label: "编辑时间",
                          width: "140",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.updated_at
                                        ? _setup.parseTime(row.updated_at)
                                        : "--"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: "状态",
                          width: "80",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.status === 1 ? "success" : "info",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.status === 1 ? "启用" : "停用"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "100",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleEditQuestion(row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleDeleteQuestion(row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "15px",
                      },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _setup.questionPage,
                          "page-sizes": [10, 20, 30, 50],
                          "page-size": _setup.questionPageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _setup.questionTotal,
                        },
                        on: {
                          "size-change": _setup.handleQuestionSizeChange,
                          "current-change": _setup.handleQuestionPageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(_setup.FaqCategoryDialog, {
        attrs: {
          visible: _setup.categoryDialogVisible,
          "dialog-title": _setup.categoryDialogTitle,
          "form-data": _setup.currentCategoryForm,
        },
        on: {
          "update:visible": function ($event) {
            _setup.categoryDialogVisible = $event
          },
          success: _setup.handleCategoryDialogSuccess,
        },
      }),
      _c(_setup.FaqQuestionDialog, {
        attrs: {
          visible: _setup.questionDialogVisible,
          "dialog-title": _setup.questionDialogTitle,
          "form-data": _setup.currentQuestionForm,
          "category-options": _setup.categoryOptions,
        },
        on: {
          "update:visible": function ($event) {
            _setup.questionDialogVisible = $event
          },
          success: _setup.handleQuestionDialogSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }